<ngx-nowrap-layout>
  <div class="row">
    <div class="col-md-12"
      style="height: 100vh;width: 100vw;display: flex;flex-flow:column nowrap;align-items: center;justify-content: center;margin-top: -3rem;">
      <h2 class="title">404 Page Not Found</h2>
      <small class="sub-title">The page you were looking for doesn't exist</small>
      <button nbButton fullWidth (click)="goToHome()" type="button" class="home-button">
        Take me home
      </button>
    </div>
  </div>
</ngx-nowrap-layout>